var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2414 0.271223C12.4526 -0.0904072 11.5474 -0.090408 10.7586 0.271223L0.586197 4.93497C0.229203 5.09864 0 5.45767 0 5.8532V15.4946C0 16.6671 0.671597 17.7341 1.72363 18.233L11.5745 22.9042C11.84 23.03 12.1468 23.032 12.4138 22.9096L22.2414 18.4039C23.3124 17.9129 24 16.8358 24 15.6492V5.8532C24 5.45767 23.7708 5.09864 23.4138 4.93497L13.2414 0.271223ZM12.4138 2.10768C12.1509 1.98714 11.8491 1.98714 11.5862 2.10768L3.41661 5.8532L5.64473 6.87473L14.1925 2.92316L12.4138 2.10768ZM17.8075 4.58055L9.25977 8.53212L12 9.78843L20.5834 5.8532L17.8075 4.58055ZM22 7.41961L13 11.5458V20.4249L21.4138 16.5675C21.7708 16.4038 22 16.0448 22 15.6492V7.41961ZM11 20.4026V11.5458L8.5 10.3997V19.2172L11 20.4026ZM4.5 17.3204V8.56579L2 7.41961V15.4946C2 15.8854 2.22387 16.2411 2.57454 16.4074L4.5 17.3204Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockGray);
export default __webpack_public_path__ + "static/media/stockGray.81783ec2a2f7c7a67ea3ff125b1f3a9c.svg";
export { ForwardRef as ReactComponent };